import React from "react";
import FadeInSection from "../../components/FadeInSection";

const Intro = () => {
    return(
        <FadeInSection>
            <br></br>
            <section className="row gap-2" id="intro">
                <article className="container">
                    <div className="col-12-xs col-6-md col-4-lg">
                        <div className="card">
                            <h3>Improve The Financial Health of Your Club</h3>
                            <p>Streamline your workflows, automate repetitive tasks, and always stay on the pulse of your organization’s finances.</p>
                            <p><strong>Grassroots360</strong> helps you manage your clubs finances and cut down on missed or late payments while creating new ways to generate revenue.</p>
                        </div>
                    </div> 
                    <div className="col-12-xs col-6-md col-8-lg">
                        <div className="card">
                            <h3>Manage Your Club's Assets &amp; Resources All In 1 Place!</h3>
                            <p>Managing a football team's assets can be a complex and time-consuming process, but with a centralized football management software system, everything becomes more streamlined and efficient.</p>
                            <p><strong>Grassroots360</strong> brings together all aspects of team management, from player management, fixture scheduling, finance data and equipment inventory. By having all this information stored in one place, managers, coaches, and staff can make data-driven decisions faster and collaborate more effectively.</p>
                        </div>
                    </div>     
                    
                </article>
            </section>
            </FadeInSection>
    )
}

export default Intro;